define([
    "jquery",
    "underscore",
    "marionette",
    "google_analytics",
    "facebook_pixel",
], function ($, _, Marionette, GoogleAnalytics, FacebookPixel) {

    return Marionette.View.extend({
        el: '#content_layout',

        ui: {},

        events: {},

        initialize: function () {
            this.bindUIElements();

            let gaUrl = GoogleAnalytics.googleAnalyticsUrls.land_prime_open;
            if (window.success) {
                gaUrl = GoogleAnalytics.googleAnalyticsUrls.land_prime_completion;

                FacebookPixel.sendCustomEvent(FacebookPixel.facebookEventNames.land_prime_success);
            }

            GoogleAnalytics.sendGaPageviewEvent(gaUrl);
        },
    });
});
